import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import * as logUtil from '@/utils/logUtil'
import mainVm from '@/main'
const TAG = '[utils/request]';
const debug = false;
const log = (...args) => {
  logUtil.t(debug, TAG, ...args)
};
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 20 * 1000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {
  console.log('baseURL: ', config.baseURL); // config['url']
  console.log('request url: ', config.url); // config['url']
  if (store.getters.token) {
    config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  log(error); // for debug
  mainVm.$message({
    type: 'warning',
    message: error
  });
  Promise.reject(error)
});

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
   * code为非200和非201是抛错 可结合自己业务进行修改
  */
    log('respone拦截器:', response);
    const res = response.data;
    if (response.status !== 200 && response.status !== 201) {
      log('respone状态码不是200也不是201:', response.status);

      mainVm.$message({
        type: 'error',
        message: res.msg
      });

      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      });

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }


      return Promise.reject(new Error('error'))
    } else {
      log('成功response:', response);
      return response
    }
  },
  error => {
    // console.log( '网络请求失败了error:', error)// for debug
    // console.log('网络请求失败了 error.response:', error.response)// for debug
    // log.d(TAG, 'error:', JSON.parse(JSON.stringify(error)))// for debug
    // console.log(typeof (error)) // object
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    //error结构： error.message


    mainVm.$message({
      type: 'error',
      message: error.response.data.msg
    });
    return Promise.reject(error)
  }
);

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js